module.exports = __webpack_public_path__ + "media/bridge_reference1.0a40ad21.mp3";